// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1MczB","detailsBorder":"styles_detailsBorder__1TAo_"};